import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { PERFORMANCE_CHART_COLOR } from './accountPerformance.consts';

const DOT_DIAMETER = 18;

const useStyles = buildUseStyles('PerformanceLineDot', (theme) => ({
  performanceDot: {
    backgroundColor: theme.palette.common.white,
    borderRadius: '50%',
    borderWidth: 3,
    borderStyle: 'solid',
    borderColor: PERFORMANCE_CHART_COLOR,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '1em',
    overflow: 'hidden',
    height: '100%',
    width: '100%',
  },
}));

export default function PerformanceLineDot(props) {
  const {
    cx, cy, payload,
  } = props;

  const classes = useStyles();

  const modelChangeEvents = payload.modelChangeEvents?.resources().list();

  if (!modelChangeEvents?.length) return null;

  return (<>
    <foreignObject
      x={cx - DOT_DIAMETER / 2}
      y={cy - DOT_DIAMETER / 2}
      width={DOT_DIAMETER}
      height={DOT_DIAMETER}
    >
      <Box className={classes.performanceDot} />
    </foreignObject>
  </>);
}
